import { Inject, Injectable } from '@angular/core';

import { SESSION_STORAGE } from '@app/modules/core/tokens/app.tokens';
import { SessionStorage } from '@app/modules/core/interfaces/session-storage';
import { encodeURIParams } from '@app/mappers/encoding.mapper';
import {
  HISTORY_DATA,
  HOTEL_SEARCH_DESTINATION_IATA, HOTEL_SEARCH_DESTINATION_ID, HOTEL_SEARCH_DESTINATION_TYPE
} from '@hotels/hotel-search/constants/search-props';
import { HotelDestinationInputType } from '@shared/base-search-bar/entities/autocomplete-destionation';
import { HistoryItem } from '@app/entities/router-state.entity';
import { DEFAULT_SEARCH_DATA_PASSENGERS, SEARCH_DATA_PASSENGERS } from '@app/constants/session-storage.constants';
import { SearchDataPassengers } from '@shared/base-search-bar/entities/search-data-passengers';

@Injectable()
export class SessionStorageService {

  constructor(
    @Inject(SESSION_STORAGE) private sessionStorage: SessionStorage
  ) { }

  public setEncodeDestinationId(id: number): void {
    this.sessionStorage.setItem(HOTEL_SEARCH_DESTINATION_ID, encodeURIParams(id?.toString()));
  }

  public setEncodeDestinationType(type: HotelDestinationInputType): void {
    this.sessionStorage.setItem(HOTEL_SEARCH_DESTINATION_TYPE, encodeURIParams(type));
  }

  public setEncodeDestinationIATA(iata: string): void {
    this.sessionStorage.setItem(HOTEL_SEARCH_DESTINATION_IATA, encodeURIParams(iata));
  }

  public removeAllHotelSearchData(): void {
    this.sessionStorage.removeItem(HOTEL_SEARCH_DESTINATION_ID);
    this.sessionStorage.removeItem(HOTEL_SEARCH_DESTINATION_TYPE);
    this.sessionStorage.removeItem(HOTEL_SEARCH_DESTINATION_IATA);
  }

  public setHistory(history: HistoryItem[]): void {
    this.sessionStorage.setItem(HISTORY_DATA, JSON.stringify(history));
  }

  public setSearchDataPassengers(searchData: SearchDataPassengers): void {
    this.sessionStorage.setItem(SEARCH_DATA_PASSENGERS, JSON.stringify(searchData));
  }

  // Temporal logic until Netactica solution 
  public setActivityName(name: string): void {
    this.sessionStorage.setItem('activity_name', name);
  }

  // Temporal logic until Netactica solution 
  public getActivityName(): string {
    return this.sessionStorage.getItem('activity_name');
  }

  // Temporal logic until Netactica solution 
  public removeActivityName(): void {
    this.sessionStorage.removeItem('activity_name');
  }

  public getSearchDataPassengers(): SearchDataPassengers {
    const searchData = this.sessionStorage.getItem(SEARCH_DATA_PASSENGERS);
    return searchData ? JSON.parse(searchData) : DEFAULT_SEARCH_DATA_PASSENGERS;
  }

  public getHistory(): HistoryItem[] {
    const history = this.sessionStorage.getItem(HISTORY_DATA);
    return history ? JSON.parse(history) : null;
  }


}
